import { track } from 'src/tracking/analytics';

export const trackPopupSeen = () => track('Signup Popup - Seen');
export const trackPopupSubmit = () => track('Signup Popup - Submit');
